import { render, staticRenderFns } from "./StChat.vue?vue&type=template&id=f1b0334a"
import script from "./StChat.vue?vue&type=script&lang=ts"
export * from "./StChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports